export const aboutText = `is an advanced wealth intelligence platform designed to help everyday 
investors make more informed decisions through data-driven insights, portfolio analytics, and personalized 
wealth-building intelligence.
Whether you’re just starting your journey or managing significant assets, Forge Ultra equips you with 
institutional-grade tools that simplify complexity, reduce risk, and amplify returns — all in one powerful, 
easy-to-use platform.`

export const MEMBERSHIP_URL = 'https://www.ki-wealth.com/membership-levels/'

export const serviceCards = [
  {
    icon: 'bx bx-shield-quarter',
    title: 'Investor Risk Intelligence™',
    subtitle: 'Understand Your True Investment Risk Before It Costs You Money',
    description:
      'Build a personalized investor risk profile, align your portfolio with your financial goals, and ' +
        'stress-test your investments across multiple economic scenarios. Analyze market crashes, inflation ' +
        'spikes, interest-rate shocks, tax impacts, and dividend distributions to understand how risk affects ' +
        'your long-term wealth. Make smarter decisions with institutional-grade portfolio risk intelligence.',
    benefits: [
      'Personalized risk profiling',
      'Goal-based risk alignment',
      'Portfolio stress testing',
      'Inflation and recession simulations',
      'Tax-adjusted risk analysis',
      'Dividend impact analysis',
    ],
    ctaLabel: 'Discover Your Investor Risk Score →',
    ctaHref: MEMBERSHIP_URL,
  },
  {
    icon: 'bx bx-pie-chart-alt-2',
    title: 'Smart Portfolio Builder™',
    subtitle: 'Build Your Optimal Portfolio With Institutional-Grade Intelligence',
    description:
      'Create personalized stock, ETF, and UCITS ETF portfolios designed to maximize long-term risk-adjusted ' +
        'returns. Optimize allocations across multiple asset classes, currencies, and investment goals while ' +
        'uncovering opportunities to improve diversification and portfolio efficiency. Turn professional portfolio ' +
        'construction techniques into a simple and actionable investment plan.',
    benefits: [
      'Personalized wealth allocation engine',
      'Stock-only portfolio builder',
      'ETF & UCITS ETF portfolio construction',
      'Multi-currency investing',
      'Multi-asset portfolio optimization',
      'Advanced portfolio analytics',
    ],
    ctaLabel: 'Build My Portfolio →',
    ctaHref: MEMBERSHIP_URL,
  },
  {
    icon: 'bx bx-target-lock',
    title: 'Investment Opportunity Scanner™',
    subtitle: 'Discover What To Buy Now And Why',
    description:
      'Identify the most attractive investment opportunities across asset classes, sectors, industries, and ETFs ' +
        'using data-driven rankings and quantitative research. Access actionable Buy and Sell price zones, trend ' +
        'analysis, momentum signals, and opportunity scoring designed to help you allocate capital where the ' +
        'risk-reward profile is strongest.',
    benefits: [
      'Daily asset class rankings',
      'Sector leadership analysis',
      'ETF opportunity rankings',
      'Buy and Sell price targets',
      'Momentum and trend analysis',
      'Tactical allocation insights',
    ],
    ctaLabel: "Find Today's Best Opportunities →",
    ctaHref: MEMBERSHIP_URL,
  },
  {
    icon: 'bx bx-trophy',
    title: 'Financial Freedom Playbooks™',
    subtitle: 'Follow Proven Wealth-Building Strategies With Confidence',
    description:
      'Access a library of evidence-based portfolio strategies designed to help investors build wealth, improve ' +
        'portfolio performance, and achieve financial independence. Compare Robo-Advisor approaches, test ' +
        'rebalancing schedules, backtest investment ideas, and build future portfolios based on thousands of ' +
        'historical market scenarios.',
    benefits: [
      'Wealth-building strategy library',
      'Robo-Advisor comparison engine',
      'Portfolio rebalancing optimization',
      'Strategy backtesting',
      'Future portfolio forecasting',
      'Long-term wealth projections',
    ],
    ctaLabel: 'Build My Wealth Strategy →',
    ctaHref: MEMBERSHIP_URL,
  },
]

export const marketRadar = {
  icon: 'bx bx-broadcast',
  eyebrow: 'Daily Market Intelligence',
  title: 'Forge Ultra Market Radar™',
  subtitle: 'Stay Ahead Of The Market With Daily Investment Intelligence',
  description:
    'Receive strategic investment playbooks powered by macroeconomic analysis, Treasury yield curve signals, ' +
      'real-yield trends, and global market data. Monitor sector rotations, identify changing market regimes, and ' +
      'gain forward-looking insights to position your portfolio before major market moves occur.',
  benefits: [
    'Daily investment playbooks',
    'Treasury yield curve analysis',
    'Real-yield monitoring',
    'Macro regime forecasting',
    'Sector rotation intelligence',
    'Tactical market outlooks',
  ],
  ctaLabel: "See Today's Market Outlook →",
  ctaHref: MEMBERSHIP_URL,
}

export const wealthAssistant = {
  icon: 'bx bx-bot',
  eyebrow: 'Ask. Learn. Plan. Build Your Financial Future with Confidence.',
  title: 'Forge Ultra™ Wealth-Building Assistant',
  subtitle: "The Wealth-Building Assistant That's Tailored to You and Your Financial Journey",
  description: [
    'The Forge Ultra™ Wealth-Building Assistant is your personalized financial learning companion designed to ' +
      'help you better understand investing, portfolio construction, financial planning, and long-term wealth creation.',
    "Whether you're exploring investment strategies, building your first portfolio, evaluating risk, planning " +
      'financial goals, or learning how professional wealth-building methodologies work, your Wealth-Building ' +
      'Assistant is available whenever you need guidance.',
    'Ask questions, explore ideas, learn proven investment concepts, and gain deeper insights into the strategies ' +
      'and frameworks that power the Forge Ultra™ Wealth-Building Platform.',
  ],
  features: [
    { icon: 'bx bx-bulb', label: 'Learn the "Why" Behind Your Portfolio' },
    { icon: 'bx bx-message-square-dots', label: 'Ask Any Investing Question' },
    { icon: 'bx bx-cog', label: 'Discover How Forge Ultra Works' },
    { icon: 'bx bx-target-lock', label: 'Get Highly Personalized Guidance' },
  ],
  ctaLabel: 'Explore Investing with Confidence',
  ctaHref: MEMBERSHIP_URL,
}

export const calculatorCards = [
  {
    emoji: '🚀',
    icon: 'bx bx-rocket',
    title: 'ETF Wealth Builder Calculator',
    description:
      'Discover how much your ETF portfolio could be worth in 10, 20, 30 or more years based on your monthly ' +
        'contributions, expected returns, and inflation assumptions.',
    ctaLabel: 'Calculate My Future Wealth',
    to: '/free-tools/etf-wealth-builder',
  },
  {
    emoji: '🎯',
    icon: 'bx bx-target-lock',
    title: 'Financial Freedom Calculator',
    description:
      'See how quickly your investments can reach financial independence and generate enough wealth to support ' +
        'your desired lifestyle.',
    ctaLabel: 'Calculate My Freedom Date',
    to: '/free-tools/financial-freedom',
  },
  {
    emoji: '🧩',
    icon: 'bx bx-pie-chart-alt-2',
    title: 'Portfolio Diversification Analyzer',
    description:
      'Is your portfolio more concentrated than you think? In just a few moments, discover where your biggest ' +
        'exposures lie and whether your investments are working together to support a stronger, more diversified ' +
        'portfolio.',
    ctaLabel: 'Is My Portfolio Well-Diversified?',
    to: '/free-tools/portfolio-diversification-checker',
    newTab: true,
  },
  {
    emoji: '📉',
    icon: 'bx bx-trending-down',
    title: 'Portfolio Drift & Rebalancing Auditor',
    description:
      'Doing nothing has a cost. See how your allocation silently drifts over time, how much wealth the ' +
        '"volatility tax" quietly erodes, and whether disciplined rebalancing would have cut your drawdowns and ' +
        'tail risk.',
    ctaLabel: 'Audit My Portfolio',
    to: '/free-tools/portfolio-drift-auditor',
    newTab: true,
  },
]
